import * as React from 'react';
import { BarChart } from '@mui/x-charts/BarChart';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Slider from '@mui/material/Slider';
import Typography from '@mui/material/Typography';

const FourEndpointError = ({ errorData }) => {
    const [layout, setLayout] = React.useState('vertical');
    const [radius, setRadius] = React.useState(10);

    if (!errorData || errorData.length === 0) {
        return <Typography>No error data available</Typography>;
    }

    // Extract unique status codes
    const allStatusCodes = new Set();
    errorData.forEach((entry) => {
        entry.statuses.forEach((status) => allStatusCodes.add(status.statusCode));
    });
    const uniqueStatusCodes = Array.from(allStatusCodes);

    // Format dataset for chart
    const dataset = errorData.map((entry) => {
        const dataEntry = { endpoint: entry.endpoint.replace("/api/v1/tradingApis", "") };
        entry.statuses.forEach((status) => {
            dataEntry[status.statusCode] = status.count;
        });
        return dataEntry;
    });

    const chartSettings = {
        dataset,
        height: 400,
        ...(layout === 'vertical'
            ? {
                xAxis: [{ scaleType: 'band', dataKey: 'endpoint' }],
                yAxis: undefined,
            }
            : {
                yAxis: [{ scaleType: 'band', dataKey: 'endpoint' }],
            }),
        series: uniqueStatusCodes.map((code) => ({
            dataKey: code.toString(),
            // label: `Status ${code}`,
            // stack: 'stack',
            layout,
        })),
        borderRadius: radius,
        slotProps: {
            legend: {
                direction: 'horizontal',
                position: { vertical: 'bottom', horizontal: 'center' },
            },
        },
    };

    return (
        <Stack direction="column" spacing={2} sx={{ width: '100%', maxWidth: 800 }}>
            <Stack direction="row" spacing={4}>
                <TextField
                    select
                    sx={{ minWidth: 150 }}
                    label="Layout"
                    value={layout}
                    onChange={(event) => setLayout(event.target.value)}
                >
                    <MenuItem value="horizontal">Horizontal</MenuItem>
                    <MenuItem value="vertical">Vertical</MenuItem>
                </TextField>
            </Stack>

            <BarChart {...chartSettings} />
        </Stack>
    );
}
export default FourEndpointError
